const path = require('path')

module.exports = function (state) {
    return {
        extensions: [
            ".webpack.js", ".web.js",
            ".js", ".mjs", ".ts", ".tsx", ".jsx", ".vue", "coffee",
            "jpg", "png", "gif", "webp", "jpeg", "jpg", "svg",
            ".html", ".tpl", ".htm",
            ".css", ".less", ".styl", ".sass"
        ],
        alias: {
            react: 'preact-compat',
            'react-dom': 'preact-compat',
            'react-addons-css-transition-group': 'react-addons-css-transition-group',
            vue: 'vue',
            Components: path.resolve(state.PROJECT_PATH, 'src/client/components/'),
            Comps: path.resolve(state.PROJECT_PATH, 'src/client/components/'),
            // Sprites: path.resolve(PROJECT_PATH, 'dist/sprites/sprite.css'),
            Main: path.resolve(state.PROJECT_PATH, 'src/client/main/'),
            Utils: path.resolve(state.PROJECT_PATH, 'src/isomorphic/'),
            Templates: path.resolve(state.PROJECT_PATH, 'src/templates/')
        },
        modules: [
            'furtherjs/node_modules',
            'node_modules/furtherjs/node_modules',
            'node_modules',
            'spritesmith-generated'
        ]
    }
}


// WEBPACK FOOTER //
// ./src/technologies/resolvers.js